<template>
  <v-card>
    <div class="modal-header">
      <v-btn
        icon
        class="close-button"
        @click="closeModal"
      >
        <v-icon size="30">
          {{ icons.mdiClose }}
        </v-icon>
      </v-btn>
    </div>
    <div class="pt-12 pb-10 px-12">
      <div
        class="d-flex align-center mb-2"
        style="gap: 15px;"
      >
        <v-icon
          size="20"
          color="warning"
        >
          {{ icons.mdiAlertOutline }}
        </v-icon>
        <span style="font-weight: 600; font-size: 18px; color: #E7E3FC;">Detalhes do Problema</span>
      </div>
      <span style="color: #E7E3FC; font-size: 14px; font-weight: 500;">Problema encontrado em: {{ itemName }}</span>

      <div
        v-if="isLoading"
        class="d-flex justify-center align-center py-8"
      >
        <v-progress-circular
          indeterminate
          color="info"
        ></v-progress-circular>
      </div>

      <div v-else-if="problemData">
        <div class="mt-6">
          <span style="color: #E7E3FC; font-size: 16px; font-weight: 500;">Severidade do problema</span>
          <v-radio-group
            v-model="problemSeverity"
            row
            style="margin-top: 6px;"
          >
            <v-radio
              color="info"
              label="Baixo"
              value="Baixo"
            ></v-radio>
            <v-radio
              color="warning"
              label="Médio"
              value="Médio"
            ></v-radio>
            <v-radio
              color="error"
              label="Crítico"
              value="Crítico"
            ></v-radio>
          </v-radio-group>
        </div>
        <div
          class="d-flex flex-column mt-4"
          style="gap: 10px;"
        >
          <span style="color: #E7E3FC; font-size: 16px; font-weight: 500;">Descrição do Problema</span>
          <v-textarea
            v-model="problemDescription"
            rows="4"
            outlined
            label="Descrição"
            dense
            placeholder="Ex: O pneu dianteiro esquerdo está com baixa pressão."
            style="width: 100%;"
          ></v-textarea>
        </div>
        <div class="d-flex flex-column mt-4">
          <span style="color: #E7E3FC; font-size: 16px; font-weight: 500;">Fotos do problema (opcional)</span>

          <div
            v-if="errorMessage"
            class="error-message mt-2"
          >
            <v-icon
              small
              color="error"
              class="mr-2"
            >
              {{ icons.mdiAlertOutline }}
            </v-icon>
            {{ errorMessage }}
          </div>

          <div
            class="d-flex align-center mt-2"
            style="gap: 12px;"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="#E7E3FC"
                  v-bind="attrs"
                  v-on="on"
                  @click="openCamera"
                >
                  <v-icon>{{ icons.mdiCamera }}</v-icon>
                </v-btn>
              </template>
              <span>Tirar foto</span>
            </v-tooltip>

            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  color="#E7E3FC"
                  v-bind="attrs"
                  v-on="on"
                  @click="selectFromGallery"
                >
                  <v-icon>{{ icons.mdiImage }}</v-icon>
                </v-btn>
              </template>
              <span>Selecionar da galeria</span>
            </v-tooltip>
          </div>

          <input
            ref="galleryInput"
            type="file"
            accept="image/*"
            style="display: none"
            @change="handleGallerySelected"
          />

          <div
            v-if="capturedPhotos.length > 0"
            class="mt-4"
          >
            <span class="mb-3 d-block">Fotos capturadas:</span>
            <div class="photos-grid">
              <div
                v-for="(photo, index) in capturedPhotos"
                :key="index"
                class="photo-item"
              >
                <div class="photo-preview">
                  <v-progress-circular
                    v-if="photo.loading"
                    indeterminate
                    size="24"
                  />

                  <img
                    v-else
                    :src="photo.url"
                    alt="Foto do problema"
                    class="preview-image"
                  />
                </div>
                <div class="photo-actions">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        color="error"
                        size="40"
                        class="action-btn"
                        v-bind="attrs"
                        :disabled="photo.deleting"
                        v-on="on"
                        @click="removePhoto(index)"
                      >
                        <v-progress-circular
                          v-if="photo.deleting"
                          indeterminate
                          size="18"
                          width="2"
                          color="error"
                        />
                        <v-icon v-else>
                          {{ icons.mdiDeleteOutline }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Remover foto</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        icon
                        color="#E7E3FC"
                        size="40"
                        class="action-btn"
                        v-bind="attrs"
                        v-on="on"
                        @click="downloadPhoto(photo)"
                      >
                        <v-icon>
                          {{ icons.mdiDownloadOutline }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>Baixar foto</span>
                  </v-tooltip>
                </div>
              </div>
            </div>
          </div>
        </div>

        <CameraModal
          v-model="showCameraModal"
          @photo-captured="handlePhotoCaptured"
          @error="showError"
        />

        <div
          class="d-flex justify-end mt-6"
          style="gap: 12px;"
        >
          <v-btn
            color="info"
            :loading="isSubmitting"
            :disabled="isSubmitting"
            @click="submitReport"
          >
            SALVAR
          </v-btn>
        </div>
      </div>

      <div
        v-else-if="!isLoading"
        class="d-flex flex-column align-center py-8"
      >
        <v-icon
          size="48"
          color="grey"
        >
          {{ icons.mdiAlertCircleOutline }}
        </v-icon>
        <span
          class="mt-4"
          style="color: #9E9E9E;"
        >Nenhum problema reportado encontrado</span>
      </div>
    </div>
  </v-card>
</template>

<script>
import axiosIns from '@/plugins/axios'
import axiosFileApi from '@/plugins/axiosFileApi'
import axiosNewInstance from '@/plugins/newAxiosInstance'
import {
  mdiAlertCircleOutline,
  mdiAlertOutline,
  mdiCamera,
  mdiClose,
  mdiDeleteOutline,
  mdiDownloadOutline,
  mdiImage,
} from '@mdi/js'
import CameraModal from './CameraModal.vue'

export default {
  name: 'NotAccordingToModalView',
  components: {
    CameraModal,
  },
  props: {
    itemName: {
      type: String,
      required: true,
    },
    columnName: {
      type: String,
      required: true,
    },
    checklistId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      icons: {
        mdiClose,
        mdiAlertOutline,
        mdiCamera,
        mdiImage,
        mdiDeleteOutline,
        mdiDownloadOutline,
        mdiAlertCircleOutline,
      },
      isLoading: false,
      isSubmitting: false,
      problemData: null,
      problemSeverity: 'Baixo',
      problemDescription: '',
      capturedPhotos: [],
      errorMessage: '',
      showCameraModal: false,
    }
  },
  created() {
    this.loadProblemReport()
  },
  beforeDestroy() {
    this.capturedPhotos.forEach(photo => {
      if (photo.url && photo.url.startsWith('blob:')) {
        URL.revokeObjectURL(photo.url)
      }
    })
  },
  methods: {
    closeModal() {
      this.$emit('close')
    },
    async confirmDeleteImage() {
      const result = await this.$swal({
        title: 'Remover imagem',
        text: 'Tem certeza que deseja remover esta imagem? Essa ação não pode ser desfeita.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, remover',
        cancelButtonText: 'Não, cancelar',
        reverseButtons: true,
      })

      return result.isConfirmed
    },
    async loadProblemReport() {
      this.isLoading = true
      try {
        const { data } = await axiosIns.get(
          `/api/v1/solicitations/transport_vehicle_problem_report/find_by_checklist_id/${this.checklistId}`,
          {
            params: {
              column_name: this.columnName,
            },
          },
        )

        if (data && data.data) {
          this.problemData = data.data
          this.problemSeverity = data.data.problem_severity
          this.problemDescription = data.data.description

          // Carregar imagens existentes
          if (
            data.data.image_path_transport_checklist && data.data.image_path_transport_checklist.length > 0
          ) {
            this.capturedPhotos = data.data.image_path_transport_checklist.map(image => ({
              url: null,
              name: `imagem-${image.id}.jpg`,
              existing: true,
              id: image.id,
              loading: true,
              deleting: false,
            }))

            this.loadImages()
          }
        }
      } catch (error) {
        console.error('Erro ao carregar relatório de problema:', error)
        this.$swal({
          icon: 'error',
          title: 'Erro',
          text: 'Não foi possível carregar os detalhes do problema.',
        })
      } finally {
        this.isLoading = false
      }
    },
    async loadImages() {
      await Promise.all(
        this.capturedPhotos.map(async photo => {
          try {
            const response = await axiosFileApi.get(
              `/api/v1/solicitations/image/${photo.id}`,
              { responseType: 'blob' },
            )

            photo.url = URL.createObjectURL(response.data)
          } catch (error) {
            console.error(`Erro ao carregar imagem ${photo.id}`, error)
          } finally {
            photo.loading = false
          }
        }),
      )
    },
    getImageUrl(path) {
      return `${process.env.VUE_APP_AXIOS_FILE_URL || window.location.origin}/storage/${path}`
    },
    openCamera() {
      this.errorMessage = ''

      const isSecureContext = window.isSecureContext || window.location.protocol === 'https:' || window.location.hostname === 'localhost'

      if (!isSecureContext) {
        const currentUrl = window.location.href
        const httpsUrl = currentUrl.replace('http://', 'https://')
        const localhostUrl = currentUrl.replace(/http:\/\/[^:]+/, 'http://localhost')

        this.showError(`A câmera só funciona em contexto seguro:
• Tente: ${localhostUrl}
• Ou configure HTTPS e use: ${httpsUrl}`)

        return
      }

      if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
        this.showCameraModal = true
      } else if (!navigator.mediaDevices) {
        this.showError('navigator.mediaDevices não disponível - verifique se está em HTTPS ou localhost')
      } else {
        this.showError('getUserMedia não suportado neste navegador')
      }
    },
    handlePhotoCaptured(file) {
      this.processImage(file)
    },
    selectFromGallery() {
      this.$refs.galleryInput.click()
    },
    handleGallerySelected(event) {
      this.errorMessage = ''

      const file = event.target.files[0]
      if (file) {
        if (file.type.startsWith('image/')) {
          this.processImage(file)
        } else {
          this.showError('Por favor, selecione apenas arquivos de imagem.')
        }
      }

      const input = event.target
      input.value = ''
    },
    processImage(file) {
      this.errorMessage = ''

      const reader = new FileReader()
      reader.onload = e => {
        const photo = {
          file,
          url: e.target.result,
          name: file.name,
          size: file.size,
          timestamp: new Date().toISOString(),
          existing: false,
          deleting: false,
        }
        this.capturedPhotos.push(photo)
      }
      reader.readAsDataURL(file)
    },
    async removePhoto(index) {
      const photo = this.capturedPhotos[index]

      const confirmed = await this.confirmDeleteImage()
      if (!confirmed) return

      this.$set(photo, 'deleting', true)

      try {
        if (photo.existing && photo.id) {
          await axiosFileApi.delete(
            `/api/v1/solicitations/delete_image/${photo.id}`,
          )
        }

        if (photo.url && photo.url.startsWith('blob:')) {
          URL.revokeObjectURL(photo.url)
        }

        this.capturedPhotos.splice(index, 1)

        this.$swal({
          icon: 'success',
          title: 'Imagem removida',
          timer: 1500,
          showConfirmButton: false,
        })
      } catch (error) {
        console.error('Erro ao remover imagem:', error)

        this.$set(photo, 'deleting', false)

        this.$swal({
          icon: 'error',
          title: 'Erro',
          text: 'Não foi possível remover a imagem.',
        })
      }
    },
    downloadPhoto(photo) {
      const link = document.createElement('a')
      link.href = photo.url
      link.download = photo.name || `foto-problema-${Date.now()}.jpg`
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    async submitReport() {
      if (!this.problemDescription || this.problemDescription.trim() === '' || !this.checklistId || !this.columnName) {
        this.showError('Por favor, preencha todos os campos obrigatórios.')

        return
      }

      this.isSubmitting = true
      this.errorMessage = ''

      try {
        const formData = new FormData()
        formData.append('column_name', this.columnName)
        formData.append('problem_severity', this.problemSeverity)
        formData.append('description', this.problemDescription)
        formData.append('checklist_id', this.checklistId)

        // Adicionar apenas imagens novas
        this.capturedPhotos.forEach(photo => {
          if (!photo.existing && photo.file) {
            formData.append('images[]', photo.file)
          }
        })

        const response = await axiosNewInstance.post(
          '/api/v1/solicitations/transport_vehicle_problem_report/store_or_update',
          formData,
          {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          },
        )

        this.$emit('problem-updated', response.data)

        this.$swal({
          icon: 'success',
          title: 'Sucesso',
          text: 'Problema atualizado com sucesso!',
          timer: 2000,
          showConfirmButton: false,
        })

        this.closeModal()
      } catch (error) {
        console.error('Erro ao atualizar problema:', error)

        const errorMessage = error.message || 'Não foi possível atualizar o problema. Tente novamente.'

        this.$swal({
          icon: 'error',
          title: 'Erro',
          text: errorMessage,
        })
      } finally {
        this.isSubmitting = false
      }
    },
    showError(message) {
      this.errorMessage = message

      setTimeout(() => {
        this.errorMessage = ''
      }, 5000)
    },
  },
}
</script>

<style scoped>
.modal-header {
  width: 100%;
  position: relative;
}

.close-button {
  position: absolute;
  right: 20px;
  top: 25px;
}

.photos-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 100px));
  gap: 16px;
  max-width: 100%;
  justify-content: start;
}

.photo-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.photo-preview {
  position: relative;
  width: 100px;
  height: 100px;
  border-radius: 8px;
  overflow: hidden;
  border: 2px solid #e0e0e0;
  background: #f5f5f5;
  cursor: pointer;
  transition: transform 0.2s;
}

.photo-preview:hover {
  transform: scale(1.05);
}

.preview-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.photo-actions {
  display: flex;
  gap: 8px;
  justify-content: center;
}
</style>
